// API 基地址统一配置
// 可通过 Vite 环境变量覆盖，默认值保持现有配置

export const DATA_SERVER_BASE =
  import.meta.env.VITE_DATA_SERVER || 'http://49.4.7.179:18089';

export const DATA_SERVER_PATH = '/ktsy/nanjing/addp';

export const FASTGPT_BASE =
  import.meta.env.VITE_FASTGPT_URL || (window.location.hostname === 'localhost'
    ? 'http://localhost:9081'
    : 'http://49.4.7.179:9081');

export const TILE_BASE =
  import.meta.env.VITE_TILE_BASE || 'https://www.daditu.com.cn';

export const GEOCODER_URL =
  import.meta.env.VITE_GEOCODER_URL || 'https://www.daditu.com.cn';

// 拼接数据服务器完整 URL
export const dataServerUrl = (endpoint: string, params?: Record<string, string | number>) => {
  const url = new URL(`${DATA_SERVER_BASE}${DATA_SERVER_PATH}/${endpoint}`);
  if (params) {
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, String(v)));
  }
  return url.toString();
};
